




















import { Component, Mixins, Prop } from "vue-property-decorator";
import { LineStyle, Color, LineKinds, PaintStyle, TextureKinds, TextStyle, TextAlignKinds } from "../../../../../../base/domain/drawing";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { ObjectKeys } from "../../../../../domain/configuration";
import { RectangleCoordinatableObjectDrawerBase } from "./base";
import { ConfiguredTextAreaDrawer } from "./drawers";

@Component({
  components: {
    ConfiguredTextAreaDrawer,
    RectangleDragHandles,
  },
})
export default class NamedRectangleCoordinatableObjectDrawer extends Mixins(RectangleCoordinatableObjectDrawerBase) {
  @Prop()
  displayName: string;

  @Prop()
  configurationKey: ObjectKeys;

  @Prop()
  textStyle: TextStyle;

  @Prop()
  paintStyle: PaintStyle;

  @Prop()
  borderStyle: LineStyle;

  get text(): string {
    return (this.displayName && (this.displayName !== ""))
      ? this.displayName
      : "(名称未指定)";
  }

  get complementedBorderStyle(): LineStyle {
    return this.borderStyle
      ? this.borderStyle
      : new LineStyle(new Color("#ff0000"), LineKinds.Normal, 1);
  }

  get complementedPaintStyle(): PaintStyle {
    return this.paintStyle
      ? this.paintStyle
      : new PaintStyle(new Color("#ffff00"), TextureKinds.Fill);
  }

  get complementedTextStyle(): TextStyle {
    return this.textStyle
      ? this.textStyle
      : new TextStyle(new Color("#ff0000"), TextAlignKinds.MiddleCenter, 12);
  }
}
